import axios, { AxiosInstance } from 'axios';
import { HttpHeaders } from '../api';
import { gsi2Configuration } from '../config';

const protocol = gsi2Configuration?.apiUrl.includes('local')
  ? 'http://'
  : 'https://';
export const axiosInstance: AxiosInstance = axios.create({
  baseURL: gsi2Configuration?.apiUrl,
});

export const axiosCall = <T>(
  getAccessTokenSilently: CallableFunction,
  path: string,
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' | 'option' = 'get',
  payload?: unknown,
  additionalHeaders?: HttpHeaders,
): Promise<T> => {
  if (gsi2Configuration?.apiUrl === undefined)
    throw new Error('apiUrl is undefined');
  console.log('axiosCall', gsi2Configuration.apiUrl + '/' + path);
  return new Promise((resolve, reject) => {
    getAccessTokenSilently().then(
      (token: string) => {
        axiosInstance.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${token}`;
        axios({
          url: `${protocol}${gsi2Configuration?.apiUrl}/${path}`,
          method: method,
          headers: {
            Authorization: `Bearer ${token}`,
            ['Content-Type']: 'application/json',
            ...additionalHeaders,
          },
          data: payload === undefined ? undefined : payload,
        })
          .then((response: { data: T }) => {
            resolve(response.data as T);
          })
          .catch((error: Error) => {
            reject(error);
          });
      },
      err => {
        reject(err);
      },
    );
  });
};
